import React, { useState,useEffect } from "react";
import Navbar from "../Navbar";
import {
  Box,
  Button,
  Grid,
  TextField,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import PopupDialog from "./PopupDialog";
import cellEditFactory from "react-bootstrap-table2-editor";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import logo from "./Geekay-logo.png";
// import 'react-bootstrap-table2-editor/dist/react-bootstrap-table2-editor.min.css';
import "./popup.css";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import overlayFactory from "react-bootstrap-table2-overlay";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DownloadIcon from '@mui/icons-material/Download';
import swal from "sweetalert";
import Swal from "sweetalert2";
import { removeFilterTitle } from "../../util/removeFilterTitle";

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const theme = createTheme({
  palette: {
    anger: createColor("#F40B27"),
    apple: createColor("#A38A00"),
    steelBlue: createColor("#5C76B7"),
    violet: createColor("#BC00A3"),
  },
  button: {
    // Here is where you can customise the button
    fontSize: 16,
    fontWeight: 1700,
  },
});
// const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true);
const ShowBill = () => {
  const navigate = useNavigate();
  const [billInput, setbillInput] = useState({
    month: "",
    year: "",
  });
  const [month, setMonth] = useState("");
  const [type, setType] = useState("");
  const [year, setYear] = useState("2023");
  const [checkdbox, setcheckdbox] = useState(false);
  const handlemonthChange = (e) => {
    setMonth(e.target.value);
  };
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Adjust the height as needed
  };

  const centeringStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const imageStyle = {
    maxWidth: '100%',
    maxHeight: '100%',

  };
  const [completecount,setcompletecount] = useState("");
  const [showsubmit,setshowsubmit] = useState("");
  const handletypechange = (e) => {
    setType(e.target.value);
    var ans = e.target.value;

    // select Complete full billing
    if (ans === "Com") {
      e.preventDefault();
      const apiUrl = `/api/show_bill_type?month=${month}&year=${year}`;
      axios.get(apiUrl).then((res) => {
        // setcompletecount(res.data.idlr);
        // console.log(res.data.idlr,"ALIIII");
        // console.log(completecount);
        if (res.data.idlr === 0 && res.data.industrial === 0) {
          setshowsubmit(1);
          setcheckdbox(1);
          swal("Success", res.data.message, "success"); 
          // console.log("TRUEEEE");
        } else {
          swal(
            "Error",
            "Kindly Complete the Full Billing for this month",
            "error"
          );
          navigate("/certificates/downloadcertificate");
          // console.log("FALSEEEE");
        }
      });
    }

    // select Adhoc matrial billing
    if (ans === "AdhocMat") {
        // console.log('AdhocMat')
      // console.log('month',month)
      // console.log('year',year)
        e.preventDefault();
        localStorage.setItem('monthOfTest', month+'-'+year);
        swal("Success", 'You can proceed with Adhoc Matrial billing', "success");
        navigate("/certificates/adhoc_matrial");
    };

  };

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate an asynchronous operation
    removeFilterTitle(".sr-only")
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);



  const handleyearChange = (e) => {
    setYear(e.target.value);
  };
  const [list, setlist] = useState([]);
  const submitBillData = (e) => {
    e.preventDefault();
    // console.log(month,"ALI");
    // console.log(year,"ALI");
    const apiUrl = `/api/show_bill_data?month=${month}&year=${year}`;

    axios.get(apiUrl).then((res) => {
      if (res.data.status === 200) {
        // console.log(res.data.idlr);
        setlist(res.data.idlr);
        // setlist(res.data.industrial);
        // console.log(res.data.industrial);
      } else if (res.data.status === 400) {
        setbillInput({ ...setbillInput, error_list: res.data.errors });
      }
    });
  };

  const dumpBillData = async (e) => {
    e.preventDefault();
    if(month==''){
      swal("Error", 'Please Select Month and Year', "error"); 
    }else{
      // console.log('month',month)
      // console.log('year',year)
      const currentTimestamp = new Date();
      // const formattedDateTime = new Date(currentTimestamp).toLocaleTimeString().replace(/[-:]/g, '');
      const showTime = currentTimestamp.getHours() 
        + '' + currentTimestamp.getMinutes() 
        + "" + currentTimestamp.getSeconds();

      const apiUrl = `/api/billing_dump?month=${month}&year=${year}`;
      try {
        const response = await axios.get(apiUrl, {
          responseType: "blob", // This indicates that the response is a binary blob
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `billing-report-${showTime}.xlsx`;
        link.click();
      } catch (error) {
        console.error("Error downloading Excel:", error);
      }
    }
  };

  const [isPopupOpen, setPopupOpen] = useState(false);

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );
  const columns = [
    {
      dataField: "id",
      text: "ID",
    },
    {
      dataField: "billing_party_code",
      text: "Billing Party Code",
      filter: textFilter(),
    },
    {
      dataField: "vertical_type",
      text: "Vertical Type",
      filter: textFilter(),
    },
    {
      dataField: "certificate_no",
      text: "Certificate No",
    },
    {
      dataField: "party_code",
      text: "Certificate Party",
      filter: textFilter(),
    },
    {
      dataField: "remarks",
      text: "Remarks",
    },
    {
      dataField: "amount",
      text: "Amount",
    },
    {
      dataField: "invoice_no",
      text: "Invoice No",
    },
    {
      dataField: "invoice_date",
      text: "Invoice Date",
    },

  ];
  // State to keep track of selected rows
  const [selectedRows, setSelectedRows] = useState([]);
  // Function to handle row selection
  const handleRowSelect = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

 // Function to handle select all checkbox
  const handleSelectAll = (isSelected, rows) => {
    console.log("isSelected:", isSelected);
    console.log("All rows:", rows);
  
    if (isSelected) {
      const allIds = rows.map((row) => row.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
    return isSelected;
  };
  const checkSelectedData = () => {
    // Log or use the selected IDs
    console.log("Selected IDs:", selectedRows);
  } 

  const [invoice, setinvoice] = useState([]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (type === "") {
      swal("Error", "Please Select Billing Type", "error");
    } else if (type === "AdhocCer") {
      if (selectedRows.length <= 1) {
        // console.log(selectedRows[0])
        // console.log(list);
        const ans = list.find(item => item.id === selectedRows[0]);
        // console.log(ans.is_invoice_generated);
        // console.log(list[selectedRows[0]-1]);
        // console.log(list[selectedRows[0] - 1].is_invoice_generated,"fidiff");
        if (ans.is_invoice_generated === 1) {
          swal(
            "Error",
            "Invoice Already Generated for one of the certificates....Please Check!!",
            "error"
          );
        } else {
          togglePopup();
        }
      } else {
        console.log(selectedRows)
        console.log(list);
        // console.log(list[selectedRows[0]].id.is_invoice_generated);
        // console.log(list[selectedRows[0] - 1].is_invoice_generated,"fidiff");
        // console.log(list,"LIST IS GENETR");
        for (let i = 1; i <= selectedRows.length; i++) {
          let one = selectedRows[i];
          let two = selectedRows[i - 1] ;
          const first = list.find(item => item.id === one);
          const second = list.find(item => item.id === two);
          // console.log(first,'bnm,................dmnd');
          // console.log(second,"fidiff");
          if (second.is_invoice_generated === 1) {
            swal(
              "Error",
              "Invoice Already Generated for one of the certificates....Please Check!!",
              "error"
            );
          } else {
            if (first.party_code !== second.party_code) {
              e.preventDefault();
              swal("Error", "Please select same party codes only", "error");
            } else {
              togglePopup();
            }
          }
        }
      }
    }
  };



  const submitcompletebilling = () => {
    // e.preventDefault();
    // console.log(month,"ALI");
    // console.log(year,"ALI");
    // const apiUrl = `/api/view-invoices?startDate=${sDate}&endDate=${eDate}`;
    const data = {
      month: month,
    }

    setIsLoading(true);
    axios.post(`/api/store_completebilling_invoice`,data).then((res) => {
      if (res.data.status === 200) {
        setIsLoading(false);
        // console.log(res.data.idlr);
        swal(
          "Success",
          "Invoice Generated Successfully!!!",
          "success"
        );
        // setlist(res.data.industrial);
        // console.log(res.data.industrial);
      } else if (res.data.status === 400) {
        setIsLoading(false);
        // setbillInput({ ...setbillInput, error_list: res.data.errors });
        swal(
          "Error",
          "Data Not Found !....Please Check!!",
          "error"
        );
      }else{
        setIsLoading(false);
        // setbillInput({ ...setbillInput, error_list: res.data.errors });
        swal(
          "Error",
          "Something went wrong! Please check again and contact the team.",
          "error"
        );
      }
    });
  };

  const [showPopup, setShowPopup] = useState(false);
  const [popupdata, setPopupdata] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  

  const handleinvoiceDate = (e) => {
    setPopupdata(e.target.value);
  };
  var invoicedate = false;

  const onPopupSubmit = () => {
    var check = popupdata.split("-");
    var popupyear = check[0];
    // var month = check[1];
    var today = new Date(popupdata);
    var popupmonth = today.toLocaleString("default", { month: "short" });
    if (popupmonth !== month || popupyear !== year) {
      setErrorMessage("Please select date within the Certificate Date");
    }else {
      axios.post(`api/check_date`,{popupdata}).then((res) => {
        if(res.data.status === 201){
          setErrorMessage(res.data.message);
        }
        else{
          axios.post(`/api/store_invoice`, { selectedRows,popupdata }).then((res) => {
            if (res.data.status === 200) {
              togglePopup();
              swal(
                "Success",
                "Invoice Generated Successfully!!!",
                "success"
              );
            } else if (res.data.status === 404) {
              swal(
                "Error",
                "Something Went Wrong",
                "error"
              );
            }
          });
        }
      });
      
      
    }
  };

  return (
    <div>
      {isLoading ? (
        <div style={containerStyle}>
          <div style={centeringStyle}>
            <img src="https://media4.giphy.com/media/ifYdEz0ayL5ZoUxl4M/giphy.gif" alt="Loading..." alt="Centered Image" style={imageStyle} />
          </div>
        </div>
      ) : (
           <div>
      <Navbar />
      <div className="row" style={{ marginTop: 20, width: "97%" }}>
        <div className="col-sm-12" style={{ marginLeft: 40 }}>
          <div className="card">
            <div className="card-header">
              <h4>
                <b>Billing</b>
              </h4>
            </div>
            <form onSubmit={submitBillData} id="REPORT_FORM">
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-2" style={{ marginBottom: "15px" }}>
                    <label>Select Month</label>
                    <select
                      id="month"
                      value={month}
                      onChange={handlemonthChange}
                      name="month "
                      className="form-control"
                    >
                      <option value="">-- Month --</option>
                      <option value="Jan">January</option>
                      <option value="Feb">February</option>
                      <option value="Mar">March</option>
                      <option value="Apr">April</option>
                      <option value="May">May</option>
                      <option value="Jun">June</option>
                      <option value="Jul">July</option>
                      <option value="Aug">August</option>
                      <option value="Sep">September</option>
                      <option value="Oct">October</option>
                      <option value="Nov">November</option>
                      <option value="Dec">December</option>
                    </select>
                  </div>
                  <div className="col-sm-2" style={{ marginBottom: "15px" }}>
                    <label>Year</label>
                    <input
                      type="number"
                      value={year}
                      onChange={handleyearChange}
                      id="year"
                      name="year"
                      className="form-control"
                      defaultValue="2022"
                      min="1900"
                      max="2099"
                      step="1"
                    ></input>
                  </div>
                  <div className="col-sm-2" style={{ marginBottom: "15px" }}>
                    <ThemeProvider theme={theme}>
                      <Box
                        //  marginTop={}
                        display="flex"
                        padding={3}
                        borderRadius={5}
                        alignItems="center"
                        justifyContent={"center"}
                      >
                        {/*<ThemeProvider theme={theme}>*/}
                        <Button
                          style={{
                            maxWidth: "200px",
                            maxHeight: "100px",
                            minWidth: "50px",
                            minHeight: "30px",
                          }}
                          color="apple"
                          type="submit"
                          variant="contained"
                        >
                          Submit
                        </Button>
                      </Box>
                    </ThemeProvider>
                  </div>
                  <div>
                    {list == "" ? (
                      <div></div>
                    ) : (
                      <div className="row">
                      <div
                        className="col-sm-3"
                        style={{ marginTop: "-15px" }}
                      >
                        <label>Select Billing</label>
                        <select
                          id="type"
                          value={type}
                          onChange={handletypechange}
                          name="type "
                          className="form-control"
                        >
                          <option value="">-- Billing Type --</option>
                          <option value="Com">
                            Complete full Month Billing
                          </option>
                          <option value="AdhocMat">
                            Adhoc Material Billing
                          </option>
                          <option value="AdhocCer">
                            Adhoc Certificate Billing
                          </option>
                        </select>
                      </div>
                      {showsubmit === ""? (
                        <div></div>
                      ) : (
                        <div className="col-sm-3">
                        <ThemeProvider theme={theme}>
                      <Box
                        //  marginTop={}
                        display="flex"
                        padding={3}
                        borderRadius={5}
                        alignItems="center"
                        justifyContent={"center"}
                      >
                        {/*<ThemeProvider theme={theme}>*/}
                        <Button
                          style={{
                            maxWidth: "200px",
                            maxHeight: "100px",
                            minWidth: "50px",
                            minHeight: "30px",
                          }}
                          color="apple"
                          type="submit"
                          onClick={submitcompletebilling}
                          variant="contained"
                        >
                          Click to start complete billing
                        </Button>
                      </Box>
                    </ThemeProvider>
                        </div>
                      )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="card">
            <div className="card-header row">
              <div className="col-sm-6">
                <h4>
                  <b>Billing Details</b>
                </h4>
              </div>
              <div
                className="col-sm-4"
                style={{ textAlign: 'right' }}
              >
                <ThemeProvider theme={theme}>
                  <Button
                    color="apple"
                    size="medium"
                    onClick={submitBillData}
                    startIcon={<AutorenewIcon color="inherit" />}
                  ></Button>
                </ThemeProvider>
              </div>
              <div
                className="col-sm-1"
                style={{ textAlign: 'right' }}
              >
                <ThemeProvider theme={theme}>
                  <Button
                    color="apple"
                    size="medium"
                    onClick={dumpBillData}
                    startIcon={<DownloadIcon color="inherit" />}
                  ></Button>
                </ThemeProvider>
              </div>
              {showsubmit !== ""? (
                        <div></div>
                      ) : (
                        <div
                className="col-sm-1"
                style={{ textAlign: 'right' }}
              >
                <ThemeProvider theme={theme}>
                  <Button
                    color="apple"
                    size="medium"
                    onClick={onSubmit}
                    startIcon={<DoneAllIcon color="inherit" />}
                  ></Button>
                </ThemeProvider>
              </div>
                      )}
              
              </div>
            <div>
              {/* <PopupDialog isOpen={isPopupOpen} onClose={closePopup} /> */}
              {showPopup && (
                <div className="popup">
                  <div className="popup-content">
                    <h2>Please Select Invoice Date</h2>
                    <input
                      id="popupdata"
                      value={popupdata}
                      onChange={handleinvoiceDate}
                      name="popupdata "
                      type="date"
                      className="form-control"
                    />
                    {errorMessage && (
                      <div className="error-message">
                        <p>{errorMessage}</p>
                      </div>
                    )}
                    <div class="button-container">
                    <button
                      onClick={onPopupSubmit}
                      className="form-control"
                      style={{
                        textAlign: "center",
                        width: "50%",
                        marginTop: "10px",
                        backgroundColor: "#A38A00",
                        color: "#FFFFFF",
                      }}
                    >
                      Submit
                    </button>
                    <button
                      onClick={togglePopup}
                      className="form-control"
                      style={{
                        textAlign: "center",
                        width: "50%",
                        marginTop: "10px",
                        backgroundColor: "#880808",
                        color: "#FFFFFF",
                      }}
                    >
                      Cancel
                    </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <BootstrapTable
              keyField="id"
              data={list}
              columns={columns}
              hover
              condensed
              disabled={checkdbox === "" ? true : false}
              // {checkbox==""}
              selectRow={{
                mode: "checkbox",
                selected: selectedRows,
                onSelect: (row, isSelect) => {
                  if(checkdbox === '' || row.Id != ''){
                    console.log(isSelect);
                    if (row.invoice_no!='') {
                      // If some condition is met, prevent the selection
                      // e.stopPropagation();
                      return false;
                    } else {
                      // Proceed with normal selection logic
                      const rowId = row.id;
                      handleRowSelect(rowId);
                    }
                  }else{
                    return false;
                  }
                },
                onSelectAll: handleSelectAll, // Add this line for select all functionality
              }}
              // cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
              // pagination={paginationFactory(options)}
              filter={filterFactory()}
              // overlay={overlayFactory()}
              wrapperClasses="table-responsive"
            />
          </div>
        </div>
      </div>
    </div>
      )}
    </div>
  );
};

export default ShowBill;
